import type {DatePickerInput as DatePickerInputType} from '@wix/wix-ui-tpa/dist/cssVars/esm/components/DatePickerInput/DatePickerInput'
import loadable from '@wix/yoshi-flow-editor/loadable'

const DatePickerInput = loadable<DatePickerInputType>(
  async () =>
    import(
      /* webpackChunkName: "date-picker" */ '@wix/wix-ui-tpa/dist/cssVars/esm/components/DatePickerInput/DatePickerInput'
    ),
  {
    resolveComponent: components => components.DatePickerInput,
  },
)

export default DatePickerInput
